import { HTMLAttributes, ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { BoltFillIcon } from '@zep/icons';
import { useViewportDevice } from '@zep/react';
import { Colors } from '@zep/ui-tokens';
import { White } from '@zep/ui-tokens/color';
import { cn } from '@zep/utils';
import { SubscribePlan } from '../../../../../../types';
import { INFINITE_MAX_CCU } from '../../../SubscriptionConst';
import S from './PlanLabel.module.scss';
export const PlanLabelMaxCcu = ({
  plan = 'free',
  children,
  style,
  maxCcu = 20
}: PlanLabelMaxCcuProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    isMobile
  } = useViewportDevice();
  const fillColor = plan === 'basic' ? Colors.MintDark : plan === 'pro' ? Colors.PrimaryDefault : Colors.Gray600;
  const gradientColor = plan === 'basic' ? 'linear-gradient(132deg, #24B6EC 1.68%, #1DCFAF 96.63%)' : plan === 'pro' ? 'linear-gradient(132deg, #588AFF 1.68%, #A572FF 96.63%)' : 'linear-gradient(132deg, #27262E 1.68%, #949CBD 96.63%)';

  // 플랜 스페이스 목록에서 사용 하는 plan label
  return <div className={S.plan_wrapper} style={{
    ...style
  }} data-sentry-component="PlanLabelMaxCcu" data-sentry-source-file="PlanLabelMaxCcu.tsx">
      <div className={S.text_wrapper}>
        <div className={cn('flex items-center justify-center rounded-[5px]', isMobile ? 'size-[15px]' : 'size-[17px]')} style={{
        background: gradientColor
      }}>
          <BoltFillIcon fill={White} width={isMobile ? 11 : 12} height={isMobile ? 11 : 12} data-sentry-element="BoltFillIcon" data-sentry-source-file="PlanLabelMaxCcu.tsx" />
        </div>
        <label className={S.text_wrapper_label} style={{
        color: fillColor
      }}>
          <span className="font-bold">{plan?.toString().toUpperCase()}</span>
          <span className="mx-[6px] inline-block font-normal text-gray-400">
            |
          </span>
          {maxCcu === INFINITE_MAX_CCU ? t('subscription:pricing.plansEnterprise.peopleUnlimited') : t('subscription:SpaceList.maxCcu', {
          ccu: maxCcu
        })}
        </label>
      </div>
      {children}
    </div>;
};
type PlanLabelMaxCcuProps = {
  plan: SubscribePlan;
  children?: ReactNode;
  style?: HTMLAttributes<HTMLDivElement>['style'];
  maxCcu?: number;
};